import { createHCarousel } from './carousel';

const holidaysContainerEls = document.querySelectorAll('.handpicked-holidays-container');

if (holidaysContainerEls.length) {
	holidaysContainerEls.forEach((holidaysContainerEl) => {
		const holidayCarouselContainerEl = holidaysContainerEl.querySelector('.holidays-carousel-container');
		const holidayCarouselEl = holidayCarouselContainerEl.querySelector('.holidays-carousel');
		const holidayCarouselItemEls = holidayCarouselEl.querySelectorAll('.carousel-item.holiday');
		const holidayCarouselFlickity = createHCarousel(holidayCarouselContainerEl);

		const holidayTagContainerEl = holidaysContainerEl.querySelector('.holiday-tags');
		if (holidayTagContainerEl) {
			const holidayTagEls = holidayTagContainerEl.querySelectorAll('.holiday-tag');
			holidayTagEls.forEach((tag) => {
				tag.addEventListener('click', (event) => {
					event.preventDefault();
					event.stopImmediatePropagation();
					const target = event.currentTarget;
					const sortedEls = holidayCarouselItemEls;

					// add active class to current clicked button
					holidayTagEls.forEach((el) => {
						el.classList.remove('active');
					});
					target.classList.add('active');

					// sort out carousels
					const cellElements = holidayCarouselFlickity.cells.map((cell) => cell.element);
					holidayCarouselFlickity.remove(cellElements);
					sortedEls.forEach((el) => {
						if (target.getAttribute('data-term') || el.getAttribute('data-tags').includes(target.getAttribute('data-tag'))) {
							holidayCarouselFlickity.insert(el);
						}
					});
					holidayCarouselFlickity.resize();
				});
			});

			const moreTagTriggerEl = holidayTagContainerEl.querySelector('.js-more-tags');
			if (moreTagTriggerEl) {
				const holidayMoreTagEl = holidayTagContainerEl.querySelector('.more-tags');
				moreTagTriggerEl.addEventListener('click', (event) => {
					const target = event.currentTarget;
					holidayMoreTagEl.classList.remove('!hidden');
					holidayMoreTagEl.replaceWith(...holidayMoreTagEl.childNodes);
					target.remove();
				});
			}
		}
	});
}
